import {
  titleUI,
  descriptionUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { aidAndAttendanceDescription } from '../../content/additionalBenefits';

export default {
  uiSchema: {
    ...titleUI('Aid and Attendance benefits or Housebound allowance'),
    ...descriptionUI(aidAndAttendanceDescription),
    'view:aidAndAttendance': yesNoUI(
      'Do you need help with everyday activities or are you confined to your home?',
    ),
  },
  schema: {
    type: 'object',
    properties: {
      'view:aidAndAttendance': { type: 'boolean' },
    },
  },
};
